import { getSubdomain } from './helpers'

export default class BrokerService {
  broker = null

  /**
   * Gets current broker in 3 different ways:
   * 1. From this helper - when previously set from other places
   * 2. From subdomain - when initially loading PWA/Desktop (not widget)
   * 3. From ENV variable set in .env config file - when testing
   */
  static getBroker() {
    // Overwrite broker if set in .env config file
    const devBroker = process.env.REACT_APP_DEV_BROKER
    if (devBroker) {
      return devBroker
    }

    if (!BrokerService.broker) {
      const subdomain = getSubdomain()

      if (subdomain === 'localhost' || subdomain === 'no-subdomain') {
        return 'clearpath'
      } else {
        return subdomain
      }
    }

    return BrokerService.broker
  }

  /**
   * Sets current broker for:
   * 1. PWA / Desktop - in src/modules/App.jsx
   * 2. Widget - in /widget/embadable.js
   */
  static setBroker(broker) {
    BrokerService.broker = broker
  }
}
